import React from 'react';

const FormSkeleton: React.FC = () => {
    return (
        <div className="animate-pulse space-y-4">
            {/* First row - 5 fields */}
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-2">
                    <div className="bg-gray-200 h-4 rounded mb-2"></div>
                    <div className="bg-gray-100 h-10 rounded"></div>
                </div>
                <div className="col-span-3">
                    <div className="bg-gray-200 h-4 rounded mb-2"></div>
                    <div className="bg-gray-100 h-10 rounded"></div>
                </div>
                <div className="col-span-2">
                    <div className="bg-gray-200 h-4 rounded mb-2"></div>
                    <div className="bg-gray-100 h-10 rounded"></div>
                </div>
                <div className="col-span-2">
                    <div className="bg-gray-200 h-4 rounded mb-2"></div>
                    <div className="bg-gray-100 h-10 rounded"></div>
                </div>
                <div className="col-span-1">
                    <div className="bg-gray-200 h-4 rounded mb-2"></div>
                    <div className="bg-gray-100 h-8 rounded"></div>
                </div>
            </div>
            
            {/* Second row - 4 badges */}
            <div className="grid grid-cols-12 gap-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={index} className="col-span-2">
                        <div className="bg-gray-100 h-6 w-16 rounded inline-block mr-2"></div>
                        <div className="bg-gray-200 h-4 w-20 rounded inline-block"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FormSkeleton;
